export enum FileStatus {
    None = 'none',
    Archived = 'archived',
    ArchivedDeleted = 'archivedDeleted',
    Deleted = 'deleted'
}
